import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {EntityLabelLinkContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import {EntityHeaderContainerModel} from '../../../../../../models/aggregates/erp/entity';

// https://api.akaun.cloud/core2/tnt/dm/erp/entity-label-links/backoffice-ep

@Injectable({
  providedIn: 'root'
})
export class EntityLabelLinkService extends BaseApiTemplateService<EntityLabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-label-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + 'entity-label-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + 'entity-label-links/backoffice-ep';
    this.httpClient = http;
  }

  getEmployees(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<EntityHeaderContainerModel>> {
    const empUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-label-links/employees/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<EntityHeaderContainerModel>>(
      empUrl,
      this.getHttpHeader(apiVisa)
    );
  }
}
